import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class SizeValidator {
    static size(size: number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            const isValid = value && value.length === size;
            // Если значение валидно, возвращаем null, иначе возвращаем объект ошибки
            return isValid ? null : { size: true, value: size };
        };
    }
}